import React from 'react';
import ReactDOM from "react-dom";
import MainTitle from '../../components/page/main-title/MainTitle';
import Button from '../../components/buttons/Button';
import TextInput from '../../components/form/TextInput';
import TextInputWithUploader from '../../components/form/TextInputWithUploader';
import TextArea from "../../components/form/TextArea";
import SelectAjax from "../../components/form/SelectAjax";
import Random from "../../utils/strings/Random";
import {FormDataToJson} from '../../utils/json/Json';
import Dialog from '../../components/alert/Dialog';
import Alert from "../../components/alert/Alert";
import PAGES from '../../config/Pages';
import Requisitions from '../../utils/requisitions/Requisitions';
import STRINGS from './../../data/language/language';
import ItemSimplesListagem from '../../components/listagem/ItemSimplesListagem';
import RadioButtonList from "../../components/form/RadioButtonList";
import WS from '../../config/Ws';

const URL_SAVE = WS.usuarios.save;

class Page extends React.Component{
  constructor (props){
    super(props);
    this.handleSubmit = this.handleSubmit.bind(this);
    this.handleClickCheckPermissao = this.handleClickCheckPermissao.bind(this);
    this.state = {
      wrapper:Random(7),
      classVisualizar:'radio-visualizar',
      classEditar:'radio-editar',
      classDeletar:'radio-deletar',
      strings:STRINGS[window.LANGUAGE],
      detalhe: props.detalhe
    };
  }

  componentDidMount() {
    //const _list_geral = document.getElementById('permissoes-geral');
    //var _checks = _list_geral.getElementsByTagName('input');
  }

  componentWillUnmount() {

  }

  handleSubmit (e){
    const formData = new FormData(e.target);
    const nome = formData.get('nome');
    const email = formData.get('email');
    const usuario = formData.get('usuario');
    const senha = formData.get('senha');

    let modal = new Alert();
    var _self = this;
    const { salvoSucesso, msgCamposObrigatoriosVideos } = this.state.strings;

    var object = FormDataToJson(formData);
    //var dataSend = JSON.stringify(object);

    const {
      atencao,
      preenchaCamposAsterisco,
      erroSalvar
    }
    = this.state.strings;

    if(nome !== '' && email !== '' && usuario !== '' && senha !== ''){
      Requisitions({
        url:URL_SAVE,
        data: object,
        sucess:function(data){
          var msg;
          _self.props.modal.close();
          _self.props.history.push(PAGES.usuarios);
          msg = {
            title: atencao,
            text: data.msg
          };
          Dialog.create(msg);
        },
        error:function(data){
          Dialog.create({
            title: atencao,
            text: erroSalvar
          });
        }
      });
    }else{
      let msg = {
        title: atencao,
        text:msgCamposObrigatoriosVideos
      };
      Dialog.create(msg);
    }

    e.preventDefault();
  }

  handleClickCheckPermissao (e){
    const _val = e.target.value;
    var _class="";
    var _check = e.target.checked;
    switch(_val){
      case 1:
      case "1":
        _class = this.state.classVisualizar;
        break;
      case 2:
      case "2":
        _class = this.state.classEditar;
        break;
      case 3:
      case "3":
        _class = this.state.classDeletar;
        break;
    }

    var _form = document.getElementById(this.state.wrapper);
    var _itens = _form.getElementsByClassName(_class);
    for (var j = 0; j < _itens.length; j++) {
        _itens[j].checked = _check;
    }
  }

  render (){
    const id = this.props.detalhe ? <input type='hidden' name='id' value={this.props.detalhe.id} /> : '';
    const nome = this.props.detalhe ? this.props.detalhe.nome : '';
    const email = this.props.detalhe ? this.props.detalhe.email : '';
    const usuario = this.props.detalhe ? this.props.detalhe.usuario : '';
    const senha = this.props.detalhe ? this.props.detalhe.senha : '';

    return (
      <div>
        <MainTitle title="Cadastro de usuário"></MainTitle>
        <form id={this.state.wrapper} onSubmit={this.handleSubmit}>
          {id}
          <div className="pure-u-15-24">
            <TextInput value={nome} name="nome" title="Nome do usuário" placeholder="Digite aqui"></TextInput>
          </div>
          <div className="pure-u-12-24">
            <TextInput value={email} name="email" title="Email" placeholder="Digite aqui"></TextInput>
          </div>
          <div className="pure-u-12-24">
            <TextInput value={usuario} name="usuario" title="Usuário" placeholder="Digite aqui"></TextInput>
          </div>
          <div className="pure-u-12-24">
            <TextInput value='' name="senha" type="senha" title="Senha" placeholder="Digite a senha"></TextInput>
          </div>
          <br /><br />
          <div className="separador"></div>
          <br />
          {/*
            <div className="wrapper-permissoes">
              <div className="wrapper-permissoes__title">Permissões de acesso</div>
              <div className="permissoes-geral" id="permissoes-geral"><RadioButtonList onClick={this.handleClickCheckPermissao} name="" title=""></RadioButtonList></div>
              <RadioButtonList name="dashboard" title="Dashboard"></RadioButtonList>
              <RadioButtonList name="videos" title="Vídeos"></RadioButtonList>
              <RadioButtonList name="planos_alimentares" title="Planos alimentares"></RadioButtonList>
              <RadioButtonList name="blocos" title="Blocos"></RadioButtonList>
              <RadioButtonList name="blocos_planilha" title="Blocos de planilha"></RadioButtonList>
              <RadioButtonList name="planilhas_treino" title="Planilhas de treino"></RadioButtonList>
              <RadioButtonList name="clientes" title="Clientes"></RadioButtonList>
              <RadioButtonList name="campanhas" title="Campanhas"></RadioButtonList>
              <RadioButtonList name="planos" title="Planos"></RadioButtonList>
              <RadioButtonList name="financeiro" title="Financeiro"></RadioButtonList>
              <RadioButtonList name="usuarios" title="Usuários"></RadioButtonList>
              <RadioButtonList name="relatorios" title="Relatórios"></RadioButtonList>
              <RadioButtonList name="perguntas" title="Perguntas frequentes "></RadioButtonList>
              <RadioButtonList name="termos" title="Termos de uso"></RadioButtonList>
              <RadioButtonList name="mensagens" title="Mensagens"></RadioButtonList>
            </div>
          */}

          <br/><br/>
          <div className="box-right-button"><Button type="submit" text="Salvar" classes="bt-save bt-blue" /></div>
        </form>
      </div>
    );
  }
}

export default Page;



// WEBPACK FOOTER //
// ./src/classes/usuarios/Page.js